import React from 'react';
import { alpha, ListItemButton, Typography, SxProps } from '@mui/material';

import { MerchantAwareLink as Link } from '../../components/core/MerchantAwareLink';

interface Props {
  label: string;
  selected?: boolean;
  path?: string;
  onClick?: () => void;
  sx?: SxProps;
  endIcon?: React.ReactNode;
}

const white = '#FFF';
export const CustomNavLink = ({
  label,
  path,
  onClick,
  selected,
  sx,
  endIcon,
}: Props): JSX.Element => {
  return (
    <ListItemButton
      disableGutters
      selected={selected}
      onClick={onClick}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(path && { component: Link, to: path })}
      sx={{
        height: '45px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pr: 1,
        color: white,
        '&:hover': {
          backgroundColor: alpha(white, 0.08),
        },
        '&.Mui-selected': {
          borderLeft: `4px solid ${white}`,
          backgroundColor: alpha(white, 0.12),
          '& p': {
            fontWeight: 600,
            paddingLeft: 2,
          },
          '&:hover': {
            backgroundColor: alpha(white, 0.12),
          },
        },
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          letterSpacing: 0.5,
          lineHeight: '21px',
          paddingLeft: 3,
          color: white,
        }}
      >
        {label}
      </Typography>
      {endIcon}
    </ListItemButton>
  );
};
